<template>
  <div class="teaching">
    <Headers></Headers>
    <div class="teaching-center">
      <div class="banner">
        <div class="text">
          <p class="tit">音乐窝教学体系</p>
          <p>
            以普及音乐、启发思维、培养审美为核心教学理念，<br />
            构建从趣味启蒙到专业系统化渐进式的“教”+“学”体系<br />
            全面启发学员的想象力、激发兴趣及创作力
          </p>
        </div>
        <img :src="bgUrl" />
      </div>
      <div class="center-body">
        <h3>系列教材</h3>
        <div class="body-text">
          <p>由音乐窝教研中心自主研发编写课程体系教材，</p>
          <p>从入门到进阶建立系统化的教学内容</p>
        </div>
        <div class="list-show"></div>
        <div class="body-lists">
          <ul>
            <li v-for="(item, index) in navData" :key="index">
              <p>{{ item.name }}</p>
              <img v-bind:src="item.imgUrl" />
            </li>
            <li>
              <p>电声乐队</p>
              <img class="band" src="../assets/img/teaching/band-1.png" />
              <img class="band" src="../assets/img/teaching/band-2.png" />
            </li>
          </ul>
          <div class="lists-mode">
            <h3>教辅工具</h3>
            <div class="body-text">
              <p>用简单、有趣、实用的教辅工具，</p>
              <p>创造不简单的教学成绩</p>
            </div>
            <img class="tool" src="../assets/img/teaching/tool.jpg" />
          </div>
          <div class="lists-APP">
            <h3>教辅APP</h3>
            <div class="body-text">
              <p>配套教材辅助教学及课后陪练，</p>
              <p>提高教学互动性及教学效果</p>
            </div>
            <div class="list-show"></div>
            <div class="APP-bodyimg">
              <img src="../assets/img/teaching/app.png" />
            </div>
          </div>
          <!-- <div class="lists-interact"></div>
          <div class="lists-oso">
            <h3></h3>
            <p></p>
          </div> -->
          <div class="Interactive_classroom">
            <h3>音乐窝智能互动课堂</h3>
            <div class="body-text">
              <p>教学APP+音乐窝智能互动教学机</p>
              <p>让老师轻松教、学生高效学！</p>
            </div>
            <div class="list-show"></div>
            <img
              src="https://aliyunosszs.musicwow.com/static/images/uploads/20200319/0d93e533dac4164a580728971db759ca.png"
            />
          </div>
          <div class="lists-item"></div>
          <div class="lists-scene">
            <h3>教学应用场景</h3>
            <div class="list-show"></div>
            <ul class="scene-images">
              <li>
                <img src="../assets/img/teaching/scene-1.jpg" />
              </li>
              <li>
                <img src="../assets/img/teaching/scene-2.png" />
              </li>
              <li>
                <img src="../assets/img/teaching/scene-3.jpg" />
              </li>
              <li>
                <img src="../assets/img/teaching/scene-4.jpg" />
              </li>
              <li>
                <img src="../assets/img/teaching/scene-5.jpg" />
              </li>
              <li>
                <img src="../assets/img/teaching/scene-6.jpg" />
              </li>
              <li>
                <img src="../assets/img/teaching/scene-7.jpg" />
              </li>
              <li>
                <img src="../assets/img/teaching/scene-8.jpg" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "Teaching",
  data() {
    return {
      active: "",
      navData: [
        {
          name: "电吉他",
          // imgUrl: '../assets/img/teaching/teaching(6).png'
          imgUrl:
            "https://aliyunosszs.musicwow.com/a8fd257ad564bc7fdfc7cc5c154afdf6.png",
        },
        {
          name: "民谣吉他",
          imgUrl:
            "https://aliyunosszs.musicwow.com/3fb911f063a06ec79b4fdc51f1df8c19.png",
        },
        {
          name: "VGM声乐",
          imgUrl:
            "https://aliyunosszs.musicwow.com/bf52d5d27a1b0763559ebc55bb2f7058.png",
        },
        {
          name: "爵士鼓",
          imgUrl:
            "https://aliyunosszs.musicwow.com/65740b7bb8dcb2e2de321062de34db34.png",
        },
        {
          name: "非洲鼓",
          imgUrl:
            "https://aliyunosszs.musicwow.com/65740b7bb8dcb2e2de321062de34db34.png",
        },
        {
          name: "尤克里里",
          imgUrl:
            "https://aliyunosszs.musicwow.com/4a0d29545c07f99d3ad7114f71727c5c.png",
        },
        {
          name: "少儿钢琴",
          imgUrl:
            "https://aliyunosszs.musicwow.com/19dfc3abe10d5fafc0d935aef41afe96.png",
        },
      ],
      listPage: 1,
      pageSum: 1, //当前页
      bgUrl: "",
    };
  },
  computed: {},
  components: {
    Headers,
    Footer,
  },
  methods: {
    async onBulist() {
      let bgData = await this.$API.getBgListData({});
      let listData = bgData.data;
      listData.forEach((item, index) => {
        switch (item.type) {
          case "mobile_teaching":
            this.bgUrl = item.image;
            break;
        }
      });
    },
  },
  mounted() {},
  created() {
    this.onBulist();
  },
};
</script>
<style lang="sass" scoped>
.teaching
  .teaching-center
    padding-top: 60px
    .banner
      position: relative
      min-height: 125px
      .text
        position: absolute
        color: #fff
        top: 18px
        left: 0
        right: 0
        font-size: 12px
        line-height: 16px
        .tit
          font-size: 20px
          line-height: 28px
          font-weight: bolder
          margin-bottom: 6px
      img
        width: 100%
    .center-body
      margin: 20px 0
      h3
        font-size: 24px
      .body-text
        font-size: 12px
        color: #9E9E9E
        margin: auto
        margin-top: 8px
        text-align: center
      .list-show
        width: 44px
        height: 5px
        background: #07D1AA
        margin: 20px auto
      .body-lists
        margin-top: 20px
        ul
          li
            img
              width: 100%
            p
              font-size: 16px
              margin: 10px 0
            .band
              width: 25%
              margin: 12px 8px
              box-shadow: 3px 3px 8px 8px #f6f6f6
      .lists-mode
        margin: 20px
        .tool
          margin-top: 24px
      .lists-APP
        margin: 40px
      .lists-scene
        margin: 15px
        .scene-images>li:nth-child(2n)
          margin-left: auto !important
          text-align: right
        .scene-images
          display: flex
          flex-wrap: wrap
          li
            width: 167px
            height: 104px
            margin-top: 15px
            img
              width: 100%
              height: 100%
      .Interactive_classroom
        margin: 72px
</style>

